import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { userSettingsStoreStateSelector } from '~/selectors';

type GeneralBooleanFlag =
  | 'isLoadingAllUserSettings'
  | 'failedToLoadAllUserSettings'
  | 'isClearingAllUserSettings'
  | 'failedToClearAllUserSettings';

type IndividualBooleanFlag =
  | 'isLoading'
  | 'failedToLoad'
  | 'isClearing'
  | 'failedToClear';

/**
 * General boolean flag will prevail over individual
 * ones to prevent the issues when individual flags
 * are not actual because of a mix of loading/clearing
 * all settings and individual ones in parallel.
 */
export const useUserSettingsBooleanFlagSelector = (
  booleanFlag: IndividualBooleanFlag,
  keys?: string[],
): boolean => {
  return useSelector((state: StoreState) => {
    const userSettingsStoreState = userSettingsStoreStateSelector(state);

    const generalBooleanFlag =
      userSettingsStoreState[
        `${booleanFlag}AllUserSettings` as GeneralBooleanFlag
      ];

    return (
      generalBooleanFlag ||
      (keys || []).some((key) => {
        return userSettingsStoreState.userSettings[key]?.[booleanFlag];
      })
    );
  });
};
